export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		en: {
			modules: {
				title: 'Modules',
				listPlaceholder: 'Modules List Component',
				tabs: {
					graphV1: 'Graph v1',
					graphV2: 'Graph v2',
				},
			},
		},
		de: {
			modules: {
				title: 'Module',
				listPlaceholder: 'Module Listenkomponente',
				tabs: {
					graphV1: 'Graph v1',
					graphV2: 'Graph v2',
				},
			},
		},
	},
}
